import React, { useEffect, useRef, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { envAwarePost } from "../../util/util";
import {
  commentRead,
  deleteEvents,
  getEventList,
  getClientData,
  getClientsList,
  getEventDetails,
  getEventComments,
  addCommentToEvent,
  emailEventToClient,
  copyEventToClients,
  addEventToFavorites,
  setAlertStateToFalse,
  changeWorkoutResults,
  getAllEventsTemplates,
  changeWorkoutComplete,
  autoFillExerciseResults,
  changeEventCompleteStatus,
  updateSimplifiedNutritionComplete,
} from "./eventsViewSlice";

import classes from "./EventsView.module.css";

import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Popover from "react-bootstrap/Popover";
import Spinner from "react-bootstrap/Spinner";
import Tooltip from "react-bootstrap/Tooltip";
import Dropdown from "react-bootstrap/Dropdown";
import Collapse from "react-bootstrap/Collapse";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import YoutubeModal from "../YoutubeModal/YoutubeModal";
import moment from "moment";
import MultiSelect from "react-multi-select-component";
import Select from "react-select";
import DatePicker from "react-datepicker";

import useApiStatusDispatch from "../../hooks/useApiStatusDispatch";


//custom hook to get query params
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

//Function to format date to the required format using moment.js
function formatDate(date) {
  return moment(date).format("ddd[,] MMM D YYYY");
}

//Function to get simplified food images
function getImg(fName) {
  if (fName == "protein") {
    return `${window.location.origin}/assets/img/icons/food/svg/fish.svg`;
  } else if (fName == "carbohydrates") {
    return `${window.location.origin}/assets/img/icons/food/svg/carbs.svg`;
  } else if (fName == "healthy fat") {
    return `${window.location.origin}/assets/img/icons/food/svg/avocado.svg`;
  } else if (fName == "fruit") {
    return `${window.location.origin}/assets/img/icons/food/svg/apple.svg`;
  } else if (fName == "vegetables") {
    return `${window.location.origin}/assets/img/icons/food/svg/broccoli.svg`;
  } else if (fName == "water") {
    return `${window.location.origin}/assets/img/icons/food/svg/beverage.svg`;
  } else {
    return `${window.location.origin}/assets/img/icons/food/svg/health.svg`;
  }
}
// Creating the UI for the status column
const Status = ({
  eventType,
  evt,
  setShouldOpenActualResults,
  shouldOpenActualResults,
  setShow,
  setShouldOpenCollapse,
  setSelectedEvent,
  shouldOpenCollapse,
  selectedEvent,
  eventsToOpen,
  setEventsToOpen,
  user,
}) => {
  const dispatch = useDispatch();
  let StatusButton;
  //Creating up the UI that displays and changes event complete status
  if (evt.complete == 0) {
    StatusButton = (
      <div
        className="far fa-square fa-2x align-middle  text-danger text-center mb-1" //red / empty
        onClick={() => {
          dispatch(
            changeEventCompleteStatus({
              complete: 1,
              event_id: evt[`${eventType}_id`],
              // client_id: evt.client_id,
              event_type: eventType,
              event_type: eventType,
            })
          );
        }}
        style={{ cursor: "pointer" }}
      ></div>
    );
  } else if (evt.complete == 1) {
    StatusButton = (
      <div
        className="fas fa-check-square fa-2x align-middle text-success text-center mb-1" //green
        style={{ cursor: "pointer" }}
        onClick={() => {
          dispatch(
            changeEventCompleteStatus({
              complete: 2,
              event_id: evt[`${eventType}_id`],
              // client_id: evt.client_id,
              event_type: eventType,
              event_type: eventType,
            })
          );
        }}
      ></div>
    );
  } else {
    StatusButton = (
      <div
        className="fas fa-window-close fa-2x align-middle text-danger text-center mb-1" //yellow
        style={{ cursor: "pointer" }}
        onClick={() => {
          dispatch(
            changeEventCompleteStatus({
              complete: 0,
              event_id: evt[`${eventType}_id`],
              // client_id: evt.client_id,
              event_type: eventType,
              event_type: eventType,
            })
          );
        }}
      ></div>
    );
  }
  //Displaying the status column content according to event type
  if (eventType == "workout") {
    return (
      <div className={["d-block d-md-flex justify-content-around"].join(" ")}>
        {StatusButton}
        {!user.isMAXUser ? (
          <div
            className={[
              classes.OptionButton,
              evt.trainerNewCommentFlag > 0 ? classes.Badge1 : null,
            ].join(" ")}
            style={{ marginBottom: 8 }}
            onClick={() => {
              setShow(true);
              dispatch(
                getEventDetails({
                  event_type: eventType,
                  event_id: evt[`${eventType}_id`],
                })
              );
              dispatch(
                getEventComments({
                  event_id: evt[`${eventType}_id`],
                  event_name: evt.title,
                  client_id: evt.client_id,
                  event_type: eventType,
                  use_json: 1,
                })
              );
              dispatch(
                commentRead({
                  event_type: eventType,
                  event_id: evt[`${eventType}_id`],
                })
              );
            }}
          >
            <i className="fas fa-comments"></i>
          </div>
        ) : (
          <div></div>
        )}
        <div
          className={classes.OptionButton}
          onClick={() => {
            setShouldOpenActualResults(!shouldOpenActualResults);
            if (shouldOpenActualResults) {
              dispatch(
                getEventDetails({
                  event_type: eventType,
                  event_id: evt[`${eventType}_id`],
                })
              );
            }
            if (
              shouldOpenCollapse == false ||
              (selectedEvent[`${eventType}_id`] != evt[`${eventType}_id`] &&
                shouldOpenCollapse)
            ) {
              setShouldOpenActualResults(true);
              setShouldOpenCollapse(false);
              // dispatch(
              //   getEventDetails({
              //     event_type: eventType,
              //     event_id: evt[`${eventType}_id`],
              //   })
              // );
              setSelectedEvent(evt);
              setEventsToOpen([...eventsToOpen, evt[`${eventType}_id`]]);
              setShouldOpenCollapse(true);
            }
          }}
        >
          <i className="fas fa-clipboard"></i>
        </div>
      </div>
    );
  } else if (eventType == "task") {
    return (
      <div className={["d-block  d-lg-flex justify-content-around"].join(" ")}>
        {StatusButton}
        {!user.isMAXUser ? (
          <div
            className={[
              classes.OptionButton,
              evt.trainerNewCommentFlag > 0 ? classes.Badge1 : null,
            ].join(" ")}
            onClick={() => {
              setShow(true);
              dispatch(
                getEventDetails({
                  event_type: eventType,
                  event_id: evt[`${eventType}_id`],
                })
              );
              dispatch(
                getEventComments({
                  event_id: evt[`${eventType}_id`],
                  event_name: evt.title,
                  client_id: evt.client_id,
                  event_type: eventType,
                  use_json: 1,
                })
              );
            }}
          >
            <i className="fas fa-comments"></i>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  } else if (eventType == "nutrition") {
    return (
      <div className={["d-block  d-lg-flex justify-content-around"].join(" ")}>
        {StatusButton}
        {!user.isMAXUser ? (
          <div
            className={[
              classes.OptionButton,
              evt.trainerNewCommentFlag > 0 ? classes.Badge1 : null,
            ].join(" ")}
            onClick={() => {
              setShow(true);
              dispatch(
                getEventDetails({
                  event_type: eventType,
                  event_id: evt[`${eventType}_id`],
                })
              );
              dispatch(
                getEventComments({
                  event_id: evt[`${eventType}_id`],
                  event_name: evt.title,
                  client_id: evt.client_id,
                  event_type: eventType,
                  use_json: 1,
                })
              );
            }}
          >
            <i className="fas fa-comments"></i>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  } else {
    return <div style={{ display: "flex" }}></div>;
  }
};

const ClientNote = ({ note }) => (
  Boolean(note) &&
  <div className="mt-2">
    <strong>Client notes</strong>: {note}
  </div>
)

const EventDetailsComponent = ({
  event,
  eventType,
  eventDetails,
  shouldOpenActualResults,
  setShouldOpenActualResults,
  setPreviewImg,
  handlePreviewShow,
  selectedEvent,
  setSelectedEvent,
}) => {
  const dispatch = useDispatch();
  const inputValHandler = (value, exercise_id, field, exercise_type) => {
    //reps and weights require the inputs to be split on , and additionally trim whitespace
    if (['reps', 'weights'].includes(field)) value = value.split(',').map(s => s.trim())
    dispatch(
      changeWorkoutResults({ [field]: value, exercise_id, type: exercise_type })
    );
  };
  const foodCompleteHandler = (prevAmount, simplifiedFoodId, amount) => {
    document.body.click();
    // console.log(prevAmount, amount)
    let completeValue = prevAmount + amount;
    dispatch(
      updateSimplifiedNutritionComplete({
        id: simplifiedFoodId,
        completed: completeValue,
        event: event,
      })
    );
  };


  //demo video
  const [demoVideoShow, setDemoVideoShow] = useState(false);
	const [demoVideo, setDemoVideo] = useState("");


  const foodFillHandler = (index, completed) => {
    let percent = Math.max(Math.min(completed - index, 1), 0) * 100;
    return percent;
  };

  //Function to change the complete status of individual exercises
  const changeExerciseCompleteStatus = (
    exercise_id,
    completeStatus,
    exercise_type,
    exerciseIndex,
    routineIndex
  ) => {
    dispatch(
      changeWorkoutComplete({
        complete: completeStatus,
        type: exercise_type,
        exercise_id: exercise_id,
        exerciseIndex,
        routineIndex,
        details: eventDetails,
      })
    );
  };




  //Displaying event details, according to event types
  if (eventType == "workout") {
    return (
      <Fragment>
        {eventDetails.long_note && (
          <div className={classes.WorkoutNotes}>
            <div className={classes.WorkoutNotesHeader}>Workout Notes: </div>
            <p>{eventDetails.long_note}</p>
          </div>
        )}
        {eventDetails.routine && eventDetails.routine.length > 0 ? (
          eventDetails.routine.map((routineVar, routineIndex) =>
            routineVar.type == "cardioSingleton" ? (
              <Table hover responsive="md">
                <thead>
                  <tr
                    style={{ backgroundColor: "#e5e7f5" }}
                    className={classes.BoldText}
                  >
                    <th className={classes.EventNameHeader}>Cardio</th>
                    <th>Time</th>
                    <th>Resistance</th>
                    <th>Distance</th>
                    <th>Rest</th>
                    <th>Incline</th>
                    <th>Notes</th>
                    <th>Options</th>
                  </tr>
                </thead>
                <tbody>
                  {routineVar.exercises.map((exercise, exerciseIndex) => (
                    <tr
                      style={
                        routineVar.color
                          ? routineVar.color == 1
                            ? { backgroundColor: "#fed3ca" }
                            : { backgroundColor: "#c4f1de" }
                          : null
                      }
                    >
                      <td>
                        <div className={classes.EventInfoBlock}>
                          <span
                            className={classes.EventName}
                            style={{ marginBottom: 10 }}
                          >
                            {exercise.name}
                          </span>
                          <span className={classes.EventTooltipIcons}>
                            <OverlayTrigger
                              key={`${exercise.demo_link}`}
                              placement={"left"}
                              overlay={
                                <Tooltip
                                  id={`tooltip-left`}
                                  className={classes.Tooltip}
                                >
                                  <p>Video demo</p>
                                </Tooltip>
                              }
                            >
                              <i
                                className={"fas fa-video"}
                                style={{
                                  marginRight: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  setDemoVideo(exercise.demoLink);
                                  setDemoVideoShow(true);
                                  e.stopPropagation();
                                }}
                              ></i>
                            </OverlayTrigger>
                          </span>
                        </div>
                      </td>
                      <td>
                        {exercise.time}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.timeResult}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "time",
                                    "cardio"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td>
                        {exercise.resistance}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.resistanceResult}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "resistance",
                                    "cardio"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td>
                        {exercise.distance}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.distanceResult}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "distance",
                                    "cardio"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td>
                        {exercise.rest}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.restResult}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "rest",
                                    "cardio"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td>
                        {exercise.incline}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.inclineResult}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "incline",
                                    "cardio"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td style={{ textAlign: "left", minWidth: "150px" }}>
                        {exercise.notes}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <textarea
                                size="3"
                                style={{
                                  width: '100%',
                                }}
                                placeholder="Results"
                                defaultValue={exercise.notes}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "notes",
                                    "cardio"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td>
                        <span>
                          <span
                            size="sm"
                            className={[
                              classes.OptionButton,
                              classes.CompleteButton,
                            ].join(" ")}
                            style={
                              exercise.complete == 1
                                ? { backgroundColor: "#00ff8c" }
                                : null
                            }
                            onClick={() => {
                              let completeStatus =
                                exercise.complete == 0 ? 1 : 0;
                              changeExerciseCompleteStatus(
                                exercise.exercise_id,
                                completeStatus,
                                "cardio",
                                exerciseIndex,
                                routineIndex
                              );
                            }}
                          >
                            <i className="fas fa-check"></i>
                          </span>
                          <Button size="sm" variant="success"></Button>
                          <span>
                            <Button
                              size="sm"
                              className={classes.FillButton}
                              onClick={() => {
                                setSelectedEvent(event);
                                dispatch(
                                  autoFillExerciseResults({
                                    type: "cardio",
                                    exercise_id: exercise.exercise_id,
                                    exerciseIndex,
                                    routineIndex,
                                    details: eventDetails,
                                  })
                                );

                                //This needs to be done because autoFill currently doesnt mark tasks as complete
                                changeExerciseCompleteStatus(
                                  exercise.exercise_id,
                                  1,
                                  "cardio",
                                  exerciseIndex,
                                  routineIndex
                                );
                                setShouldOpenActualResults(true);
                              }}
                            >
                              Fill
                            </Button>
                          </span>
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <Table hover responsive="md">
                <thead>
                  <tr
                    style={{ backgroundColor: "#e5e7f5" }}
                    className={classes.BoldText}
                  >
                    <th className={classes.EventNameHeader}>Exercise</th>
                    <th>Set</th>
                    <th>Reps</th>
                    <th>Weight</th>
                    <th>Rest</th>
                    <th>Time</th>
                    <th>Notes</th>
                    <th>Options</th>
                  </tr>
                </thead>
                <tbody>
                  {routineVar?.exercises?.map((exercise, exerciseIndex) => (
                    <tr
                      style={
                        routineVar.color
                          ? routineVar.color == 1
                            ? { backgroundColor: "#fed3ca" }
                            : { backgroundColor: "#c4f1de" }
                          : null
                      }
                    >
                      <td>
                        <div className={classes.EventInfoBlock}>
                          <span
                            className={classes.EventName}
                            style={{ marginBottom: 10 }}
                          >
                            {exercise.name}
                          </span>

                          <span className={classes.EventTooltipIcons}>
                            {exercise.demo_link && (
                              <OverlayTrigger
                                key={`${exercise.demo_link}`}
                                placement={"left"}
                                overlay={
                                  <Tooltip
                                    id={`tooltip-left`}
                                    className={classes.Tooltip}
                                  >
                                    <p>Video demo</p>
                                  </Tooltip>
                                }
                              >
                                <i
                                  className={"fas fa-video"}
                                  style={{
                                    marginRight: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={(e) => {
                                    setDemoVideo(exercise.demoLink);
                                    setDemoVideoShow(true);
                                    e.stopPropagation();
                                  }}
                                ></i>
                              </OverlayTrigger>
                            )}
                            {exercise.preview_src && (
                              <OverlayTrigger
                                key={`${exercise.preview_src}`}
                                placement={"left"}
                                overlay={
                                  <Tooltip
                                    id={`tooltip-left`}
                                    className={classes.Tooltip}
                                  >
                                    Click to Expand
                                    <img
                                      src={exercise.preview_src}
                                      style={{ width: exercise.preview_width }}
                                    />
                                  </Tooltip>
                                }
                              >
                                <i
                                  className="fas fa-eye"
                                  style={{ marginRight: "10px" }}
                                  onClick={(e) => {
                                    setPreviewImg(exercise);
                                    handlePreviewShow(true);
                                    e.stopPropagation();
                                  }}
                                ></i>
                              </OverlayTrigger>
                            )}
                            <OverlayTrigger
                              key={`${eventDetails.client_id}-${exercise.exercise_id}`}
                              placement={"left"}
                              overlay={
                                <Tooltip
                                  id={`tooltip-left`}
                                  className={classes.Tooltip}
                                >
                                  <p>Exercise weight and rep history</p>
                                </Tooltip>
                              }
                            >
                              <a
                                target="_blank"
                                href={`/viewExerciseProgressSpecific.php?client=${eventDetails.client_id}&exerciseID=${exercise.exercise_id}`}
                              >
                                <i
                                  className="fas fa-history"
                                  style={{ marginRight: "10px" }}
                                ></i>
                              </a>
                            </OverlayTrigger>
                          </span>
                        </div>
                      </td>
                      {routineVar.type == "superset" ? (
                        exerciseIndex == 0 ? (
                          <td rowSpan={routineVar.exercises.length}>
                            {exercise.sets}
                            {shouldOpenActualResults &&
                              selectedEvent[`${eventType}_id`] ==
                              eventDetails[`${eventType}_id`] && (
                                <div>
                                  <input
                                    size="3"
                                    style={{
                                      width: '100%',
                                      textAlign: 'center'
                                    }}
                                    placeholder="Results"
                                    defaultValue={exercise.setsResult}
                                    onBlur={(e) =>
                                      inputValHandler(
                                        e.target.value,
                                        exercise.exercise_id,
                                        "sets",
                                        "exercise"
                                      )
                                    }
                                  />
                                </div>
                              )}
                          </td>
                        ) : null
                      ) : (
                        <td>
                          {exercise.sets}
                          {shouldOpenActualResults &&
                            selectedEvent[`${eventType}_id`] ==
                            eventDetails[`${eventType}_id`] && (
                              <div>
                                <input
                                  size="3"
                                  style={{
                                    width: '100%',
                                    textAlign: 'center'
                                  }}
                                  placeholder="Results"
                                  defaultValue={exercise.setsResult}
                                  onBlur={(e) =>
                                    inputValHandler(
                                      e.target.value,
                                      exercise.exercise_id,
                                      "sets",
                                      "exercise"
                                    )
                                  }
                                />
                              </div>
                            )}
                        </td>
                      )}
                      <td>
                        <span className={classes.ExerciseReps}>
                          {exercise?.reps?.map((rep) => (
                            <div className={classes.IndividualRep}>{rep}</div>
                          ))}
                        </span>
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.repsResult?.join(',')}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "reps",
                                    "exercise"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td>
                        <span className={classes.ExerciseWeights}>
                          {exercise?.weights?.map((weight) => (
                            <div className={classes.IndividualWeight}>
                              {weight}
                            </div>
                          ))}
                        </span>
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.weightsResult?.join(',')}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "weights",
                                    "exercise"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td>
                        {exercise.rest}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.restResult}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "rest",
                                    "exercise"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td>
                        {exercise.time}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <input
                                size="3"
                                style={{
                                  width: '100%',
                                  textAlign: 'center'
                                }}
                                placeholder="Results"
                                defaultValue={exercise.timeResult}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "time",
                                    "exercise"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      <td style={{ textAlign: "left", minWidth: "150px" }}>
                        {exercise.notes}
                        {shouldOpenActualResults &&
                          selectedEvent[`${eventType}_id`] ==
                          eventDetails[`${eventType}_id`] && (
                            <div>
                              <textarea
                                size="3"
                                style={{
                                  width: '100%',
                                }}
                                placeholder="Results"
                                defaultValue={exercise.notesResult}
                                onBlur={(e) =>
                                  inputValHandler(
                                    e.target.value,
                                    exercise.exercise_id,
                                    "notes",
                                    "exercise"
                                  )
                                }
                              />
                            </div>
                          )}
                      </td>
                      {routineVar.type == "superset" ? (
                        exerciseIndex == 0 ? (
                          <td rowSpan={routineVar.exercises.length}>
                            <span
                            // style={{
                            //   display: "flex",
                            //   justifyContent: "space-evenly",
                            // }}
                            >
                              <span
                                size="sm"
                                className={[
                                  classes.OptionButton,
                                  classes.CompleteButton,
                                ].join(" ")}
                                style={
                                  routineVar.exercises[0].complete == 1
                                    ? { backgroundColor: "#00ff8c" }
                                    : null
                                }
                                onClick={() => {
                                  let completeStatus =
                                    exercise.complete == 0 ? 1 : 0;
                                  routineVar.exercises.forEach(
                                    (exercise, exerciseInd) =>
                                      changeExerciseCompleteStatus(
                                        exercise.exercise_id,
                                        completeStatus,
                                        "exercise",
                                        exerciseInd,
                                        routineIndex
                                      )
                                  );
                                }}
                              >
                                <i className="fas fa-check"></i>
                              </span>
                              <span>
                                <Button
                                  size="sm"
                                  className={classes.FillButton}
                                  style={
                                    exercise.complete == 1
                                      ? { backgroundColor: "#00ff8c" }
                                      : null
                                  }
                                  onClick={() => {
                                    routineVar.exercises.forEach(
                                      (exercise, exerciseIndex) => {
                                        dispatch(
                                          autoFillExerciseResults({
                                            type: "exercise",
                                            exercise_id: exercise.exercise_id,
                                            exerciseIndex,
                                            routineIndex,
                                            details: eventDetails,
                                          })
                                        );

                                        //This needs to be done because autoFill currently doesnt mark tasks as complete

                                        changeExerciseCompleteStatus(
                                          exercise.exercise_id,
                                          1,
                                          "exercise",
                                          exerciseIndex,
                                          routineIndex
                                        );
                                        setShouldOpenActualResults(true);
                                      }
                                    );
                                  }}
                                >
                                  Fill
                                </Button>
                              </span>
                            </span>
                          </td>
                        ) : null
                      ) : (
                        <td>
                          <span
                          // style={{
                          //   display: "flex",
                          //   justifyContent: "space-evenly",
                          // }}
                          >
                            <span
                              size="sm"
                              className={[
                                classes.OptionButton,
                                classes.CompleteButton,
                              ].join(" ")}
                              style={
                                exercise.complete == 1
                                  ? { backgroundColor: "#00ff8c" }
                                  : null
                              }
                              onClick={() => {
                                let completeStatus =
                                  exercise.complete == 0 ? 1 : 0;
                                changeExerciseCompleteStatus(
                                  exercise.exercise_id,
                                  completeStatus,
                                  "exercise",
                                  exerciseIndex,
                                  routineIndex
                                );
                              }}
                            >
                              <i className="fas fa-check"></i>
                            </span>
                            <span>
                              <Button
                                size="sm"
                                className={classes.FillButton}
                                onClick={() => {
                                  setSelectedEvent(event);
                                  dispatch(
                                    autoFillExerciseResults({
                                      type: "exercise",
                                      exercise_id: exercise.exercise_id,
                                      exerciseIndex,
                                      routineIndex,
                                      details: eventDetails,
                                    })
                                  );

                                  //This needs to be done because autoFill currently doesnt mark tasks as complete

                                  changeExerciseCompleteStatus(
                                    exercise.exercise_id,
                                    1,
                                    "exercise",
                                    exerciseIndex,
                                    routineIndex
                                  );

                                  setShouldOpenActualResults(true);
                                }}
                              >
                                Fill
                              </Button>
                            </span>
                          </span>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            )
          )
        ) : (
          <div></div>
        )}
        <ClientNote note={eventDetails.client_note} />
        <YoutubeModal setDemoVideoShow={setDemoVideoShow} demoVideoShow={demoVideoShow} demoVideo={demoVideo} />
      </Fragment>
    );
  } else if (eventType == "nutrition") {
    if (eventDetails.simplified == 0) {
      return (
        <Fragment>
          {eventDetails.long_note && (
            <div className={classes.WorkoutNotes}>
              <div className={classes.WorkoutNotesHeader}>Nutrition Notes:</div>
              <p>{eventDetails.long_note}</p>
            </div>
          )}
          <Table responsive="md" hover>
            <thead>
              <tr
                style={{ backgroundColor: "#e5e7f5" }}
                className={classes.BoldText}
              >
                <th style={{ width: "10%" }}>Quantity</th>
                <th>Food Name</th>
                <th>Meal Time</th>
                <th>Calories</th>
                <th>Protein(g)</th>
                <th>Carbs</th>
                <th>Fat</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {console.log("Event Details for Nut:-")}

              {/* {console.log("Nut",eventDetails.food)} */}
              {eventDetails.food &&
                eventDetails.food.length > 0 &&
                eventDetails.food.map((foodItem) => (
                  <tr>
                    <td>{foodItem.quantity}</td>
                    <td>{foodItem.name}</td>
                    <td>{foodItem.meal_time}</td>
                    <td>{foodItem.calories}</td>
                    <td>{foodItem.protein}</td>
                    <td>{foodItem.carbs}</td>
                    <td>{foodItem.fat}</td>
                    <td>{foodItem.notes}</td>
                  </tr>
                ))}
              {console.log("Nut", eventDetails.food)}
              <tr>
                <td></td>
                <td>
                  <strong className={classes.BoldText}>Totals</strong>
                </td>
                <td></td>
                <td className={classes.BoldText}>
                  {eventDetails.total_calories}
                </td>
                <td className={classes.BoldText}>{eventDetails.total_protein}</td>
                <td className={classes.BoldText}>{eventDetails.total_carbs}</td>
                <td className={classes.BoldText}>{eventDetails.total_fat}</td>
              </tr>
            </tbody>
          </Table>
          <ClientNote note={eventDetails.client_note} />
        </Fragment>
      );
    } else {
      return (
        <div>
          {eventDetails.food &&
            eventDetails.food.length > 0 &&
            eventDetails.food.map((foodItem) => (
              <div>
                <div className="mb-3">
                  {foodItem.name[0].toUpperCase() + foodItem.name.substring(1)}
                </div>
                <div>
                  {/* Creating an array out of the number of food items to map over and display */}
                  {Array(foodItem.quantity)
                    .fill()
                    .map((_, i) => (
                      <span className={classes.NutritionButton}>
                        <OverlayTrigger
                          rootClose
                          trigger="click"
                          placement="right"
                          overlay={
                            <Popover id="popover-basic">
                              <Popover.Content>
                                <div className="btn-group" role="group">
                                  <button
                                    onClick={() => {
                                      foodCompleteHandler(
                                        foodItem.completed,
                                        foodItem.id,
                                        0.25
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    1/4
                                  </button>
                                  <button
                                    onClick={() => {
                                      foodCompleteHandler(
                                        foodItem.completed,
                                        foodItem.id,
                                        0.33
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    1/3
                                  </button>
                                  <button
                                    onClick={() => {
                                      foodCompleteHandler(
                                        foodItem.completed,
                                        foodItem.id,
                                        0.5
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    2/4
                                  </button>
                                  <button
                                    onClick={() => {
                                      foodCompleteHandler(
                                        foodItem.completed,
                                        foodItem.id,
                                        0.66
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    2/3
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => {
                                      foodCompleteHandler(
                                        foodItem.completed,
                                        foodItem.id,
                                        0.75
                                      );
                                    }}
                                  >
                                    3/4
                                  </button>
                                  <button
                                    onClick={() => {
                                      foodCompleteHandler(
                                        foodItem.completed,
                                        foodItem.id,
                                        1
                                      );
                                    }}
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                  >
                                    4/4
                                  </button>
                                </div>
                              </Popover.Content>
                            </Popover>
                          }
                        >
                          <a
                            className={[
                              classes.AmountSelector,
                              "d-inline-flex",
                              "align-items-center",
                              "justify-content-center",
                              // classes[foodFillHandler(i, foodItem.completed)],
                            ].join(" ")}
                            style={{ overflow: 'hidden' }}
                          >
                            <div
                              style={{
                                left: 0,
                                top: 0,
                                position: "absolute",
                                height: "100%",
                                width: `${foodFillHandler(
                                  i,
                                  foodItem.completed
                                )}%`,
                                backgroundColor: "#00ff8c",
                                borderRadius: '50%',
                              }}
                            />
                            <img
                              src={getImg(foodItem.name)}
                              className={classes.FoodImg}
                            />
                          </a>
                        </OverlayTrigger>
                      </span>
                    ))}
                </div>
                <hr />
              </div>
            ))}
          <ClientNote note={eventDetails.client_note} />
        </div>
      );
    }
  } else if (eventType == "task") {
    return <ClientNote note={eventDetails.client_note} />
  } else {
    return <div></div>;
  }
};

const EventsView = () => {
  let query = useQuery();
  let queryParam = query.get("selector");
  let clientParam = query.get("client");
  let displayParam = query.get("display");
  let filterParam = query.get("filter");
  // let clientNameParam = query.get("clientname");
  const dispatch = useDispatch();

	const statusDispatch = useApiStatusDispatch();


  const [eventType, setEventType] = useState("");
  const [queryParamSingular, setQueryParamSingular] = useState("");
  const [commentText, setCommentText] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");
  const [shouldOpenCollapse, setShouldOpenCollapse] = useState(false);
  const [shouldOpenActualResults, setShouldOpenActualResults] = useState(false);
  const [currentClient, setCurrentClient] = useState({});
  const [copyEditClient, setCopyEditClient] = useState("");
  const [eventsToOpen, setEventsToOpen] = useState([]); //This is used to determine which events have their collapsible details section open

  useEffect(() => {
    if (queryParam == "Workouts") {
      setEventType("workout");
      setQueryParamSingular("Workout");
    } else if (queryParam == "Tasks") {
      setEventType("task");
      setQueryParamSingular("Task");
    } else if (queryParam == "Nutrition" || queryParam == "Nutritions" || queryParam == 'nutritions') {
      setEventType("nutrition");
      setQueryParamSingular("Nutrition");
    }
  }, [queryParam]);

  useEffect(() => {
    if (clientParam && filterParam == "client") {
      dispatch(getClientData({ clientID: parseInt(clientParam) }));
    }
  }, [filterParam, clientParam]);

  useEffect(() => {
    return () => {
      dispatch(setAlertStateToFalse());
      setShowAlert(false);
    };
  }, []);

  useEffect(() => {
    if (eventType != "") {
      dispatch(
        getEventList({
          event_type: eventType,
          client_id: clientParam,
          filter: filterParam,
        })
      );
    }
  }, [eventType, filterParam]);

  useEffect(() => {
    dispatch(getClientsList());
  }, []);

  const events = useSelector((state) => state.events.eventsList);

  const eventsListStatus = useSelector(
    (state) => state.events.eventsListStatus
  );
  const eventDetails = useSelector((state) => state.events.eventDetails);
  const eventDetailsStatus = useSelector(
    (state) => state.events.eventDetailsStatus
  );
  // console.log("eventDetails", events)
  const eventComments = useSelector((state) => state.events.eventComments);
  const eventCommentsStatus = useSelector(
    (state) => state.events.eventCommentsStatus
  );

  const allEventsTemplates = useSelector(
    (state) => state.events.allEventsTemplates
  );
  const eventsTemplatesStatus = useSelector(
    (state) => state.events.eventsTemplatesStatus
  );
  const clientData = useSelector((state) => state.events.clientData);
  const clientsList = useSelector((state) => state.events.clientsList);
  const clientDataStatus = useSelector(
    (state) => state.events.clientDataStatus
  );
  const emailStatus = useSelector((state) => state.events.emailStatus);

  useEffect(() => {
    if (clientsList.length > 0) {
      let specifiedClient = clientsList.find(
        (client) => client.clientIDNumber == clientParam
      );
      setCurrentClient(specifiedClient);
    }
  }, [clientsList]);

  const [filteredEvents, setFilteredEvents] = useState([]);
  const [shouldFilterEvt, setShouldFilterEvt] = useState(false);

  const [filterText, setFilterText] = useState("");

  const [filteredEventsCopy, setFilteredEventsCopy] = useState([]);

  const [sortByDate, setSortByDate] = useState(false);
  const [sortByCheck, setSortByCheck] = useState(false);

  //Comment Modal
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  //Template Modal
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const handleCloseTemplateModal = () => setShowTemplateModal(false);
  // const handleShow = () => setShow(true);

  //Delete event array
  const [deleteEventsArr, setDeleteEventsArr] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const user = useSelector((state) => state.user.user);
  const deletingEventsStatus = useSelector(
    (state) => state.events.deletingEventsStatus
  );

  //Preview Image Modal Variables
  const [showPreview, setPreviewShow] = useState(false);
  const [previewImg, setPreviewImg] = useState({});



  
  const handlePreviewClose = () => setPreviewShow(false);
  const handlePreviewShow = () => setPreviewShow(true);

  //   Copy Modal
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [clientsToCopyEvent, setClientsToCopyEvent] = useState([]);
  const [copyWorkoutName, setCopyWorkoutName] = useState("");
  const [copyWorkoutDate, setCopyWorkoutDate] = useState("");
  const [copyWorkoutStaus, setCopyWorkoutStatus] = useState(0);
  const [copyWorkoutRepeat, setCopyWorkoutRepeat] = useState("");
  const [
    copyWorkoutRepeatUntilDaily,
    setCopyWorkoutRepeatUntilDaily,
  ] = useState("");
  const [copyWorkoutDaysDaily, setCopyWorkoutDaysDaily] = useState(2);
  const [
    copyWorkoutRepeatUntilWeekly,
    setCopyWorkoutRepeatUntilWeakly,
  ] = useState("");
  const [copyWorkoutDaysWeekly, setCopyWorkoutDaysWeekly] = useState("");
  const [copyType, setCopyType] = useState("copyWorkout");

  const handleCopyClose = () => {
    setShowCopyModal(false);
    setCopyWorkoutName("");
    setCopyWorkoutDate("");
    setCopyWorkoutStatus(0);
    setCopyWorkoutRepeat("");
    setClientsToCopyEvent([]);
    setCopyWorkoutDaysDaily(2);
  };

  const setWeeklyDays = (e) => {
    if (e.target.checked) {
      setCopyWorkoutDaysWeekly([...copyWorkoutDaysWeekly, e.target.value]);
    } else {
      setCopyWorkoutDaysWeekly(
        copyWorkoutDaysWeekly.filter((day) => day != e.target.value)
      );
    }
  };

  //Alert items
  const [showAlert, setShowAlert] = useState(false);
  const showAlertState = useSelector((state) => state.events.showAlertState);
  const alertMsg = useSelector((state) => state.events.alertMsg);
  useEffect(() => {
    if (showAlertState == true) {
      setShowAlert(true);
    }
  }, [showAlertState]);

  useEffect(() => {
    if (shouldFilterEvt == true) {
      setFilteredEvents(
        events.filter((evt) => {
          return new Date(evt.date.replace(/-/g, '\/')) > new Date();
        })
      );
    } else {
      setFilteredEvents(events);
    }
    setFilteredEventsCopy(filteredEvents);
  }, [shouldFilterEvt]);

  useEffect(() => {
    setFilteredEvents(events);
    if (displayParam && displayParam != "all") {
      setFilteredEvents(
        events.filter((event) => event[`${eventType}_id`] == displayParam)
      );
    }
  }, [events]);

  //Sort by Date
  useEffect(() => {
    setFilteredEvents(filteredEventsCopy);
    if (sortByDate == true) {
      setFilteredEvents(
        filteredEvents.slice().sort((evtA, evtB) => {
          return new Date(`${evtA.date}T00:00:00`) - new Date(`${evtB.date}T00:00:00`);
        })
      );
    } else {
      setFilteredEvents(
        filteredEvents.slice().sort((evtA, evtB) => {
          return new Date(`${evtB.date}T00:00:00`) - new Date(`${evtA.date}T00:00:00`);
        })
      );
    }
  }, [sortByDate]);

  //Sort by Check
  useEffect(() => {
    setFilteredEvents(filteredEventsCopy);
    if (sortByCheck == true) {
      setFilteredEvents(
        filteredEvents.slice().sort((evtA, evtB) => {
          return evtA.complete - evtB.complete;
        })
      );
    } else {
      setFilteredEvents(
        filteredEvents.slice().sort((evtA, evtB) => {
          return evtB.complete - evtA.complete;
        })
      );
    }
  }, [sortByCheck]);

  useEffect(() => {
    if (deletingEventsStatus == "idle") {
      setShowDeleteModal(false);
    }
  }, [deletingEventsStatus]);

  useEffect(() => {
    if (showCopyModal == true && eventDetailsStatus == "idle") {
      setCopyWorkoutName(eventDetails.title);
      if (filterParam == "favorite") {
        setCopyWorkoutDate(moment().format('YYYY-MM-DD'));
      }
      else {
        setCopyWorkoutDate(eventDetails.date);
      }

      setCopyWorkoutStatus(eventDetails.published);
    }
  }, [eventDetailsStatus]);

  const emailBtnRef = useRef(null);
  useEffect(() => {
    if (emailBtnRef.current) {
      if (emailStatus == "fetching") {
        emailBtnRef.current.style.backgroundColor = "#bababa";
        emailBtnRef.current.style.cursor = "wait";
      } else {
        emailBtnRef.current.style.backgroundColor = "#f4f5f7";
        emailBtnRef.current.style.cursor = "pointer";
      }
    }
  }, [emailStatus]);

  return (
    <div className={classes.MainBody}>
      <div className={[classes.MainHeader].join(" ")}>
        {/* {clientDataStatus == "idle"
          ? clientData && filterParam == "client"
            ? clientData.clientDisplayName
              ? `${clientData.clientDisplayName}'s ${queryParam}`
              : `Client's ${queryParam}`
            : `Your Clients' ${queryParam}`
          : `${queryParam}`} */}
        {filterParam == "client"
          ? Object.keys(currentClient).length > 0
            ? `${currentClient.clientDisplayName}'s ${queryParam}`
            : `${queryParam}`
          : filterParam == "favorite"
            ? `Favorite ${queryParam}`
            : `All ${queryParam}`}
      </div>
      <hr />
      {showAlert && (
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Success
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              {alertMsg}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => {
              setShowAlert(false);
              dispatch(setAlertStateToFalse());
            }}>Close</Button>
          </Modal.Footer>
        </Modal>
      )}
      {!shouldFilterEvt && (
        <div>
          <input
            onChange={(e) => setFilterText(e.target.value)}
            className={[
              classes.FilterInput,
              "form-control shadow-sm mb-4 bg-white rounded",
            ].join(" ")}
            placeholder="Search for a workout name/ Client Name or date in the list below"
          />
        </div>
      )}

      <div className={classes.ButtonGroup}>
        {(eventType == "workout" && filterParam != "all") && (
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => {
              dispatch(getAllEventsTemplates());
              setShowTemplateModal(true);
            }}
          >
            Templates
          </Button>
        )}
        {filterParam != "all" &&
          <a
            href={`/addEvent/?client=${clientParam ? clientParam : filterParam
              }&selector=AddOrEdit&eventType=${queryParamSingular}`}
          >
            <Button size="sm" variant="success-outline">
              Add {queryParamSingular}
            </Button>
          </a>
        }
        <a href={`/programsView/`}>
          <Button size="sm" variant="primary">
            View Programs
          </Button>
        </a>
      </div>

      {/* Table */}
      <Table
        bordered
        className={classes.Table}
        responsive="md"
        data-toggle="table"
        hover
      >
        <thead>
          <tr className={classes.TableHeaderRow}>
            <th style={{ textAlign: "center" }}>
              {queryParam}
              <span
                style={{ cursor: "pointer", marginLeft: 5 }}
                onClick={() => {
                  setSortByDate((prevState) => !prevState);
                }}
              >
                <i className="fas fa-sort"></i>
              </span>
            </th>
            {filterParam == "all" && (
              <th>
                Client Name
              </th>
            )}
            <th>Option</th>
            {filterParam != "favorite" && (
              <th>
                Status
                <span
                  style={{ cursor: "pointer", marginLeft: 5 }}
                  onClick={() => {
                    setSortByCheck((prevState) => !prevState);
                  }}
                >
                  <i className="fas fa-sort"></i>
                </span>
              </th>
            )}
            {user?.permissions.edit.exercise && (
              <Fragment>
                <th style={{ display: "flex", justifyContent: "space-around" }}>
                  {/* Delete Button */}
                  <Button
                    disabled={!deleteEventsArr.length > 0}
                    size="sm"
                    variant="danger"
                    onClick={() => {
                      setShowDeleteModal(true);
                    }}
                  >
                    <i
                      className="far fa-trash-alt"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </Button>
                  {/* Check All Button */}
                  <Button
                    size="sm"

                    onClick={() => {
                      if (checkedAll == false) {
                        let eventsListTemp = [];
                        filteredEvents
                          .filter(
                            (event) =>
                              event.title.includes(filterText) ||
                              formatDate(event.date).includes(filterText) || event.client_user_name.includes(filterText)
                          )
                          .forEach((evt) => {
                            if (
                              !eventsListTemp.includes(evt[`${eventType}_id`])
                            ) {
                              eventsListTemp.push(evt[`${eventType}_id`]);
                            }
                          });

                        setDeleteEventsArr(eventsListTemp);
                        setCheckedAll(true);
                      } else {
                        setDeleteEventsArr([]);
                        setCheckedAll(false);
                      }
                    }}
                  >
                    <i className="fas fa-check"></i>
                  </Button>
                </th>
              </Fragment>
            )}
          </tr>
        </thead>
        <tbody style={{}}>
          {eventsListStatus == "failed" ? (
            <div style={{ fontSize: 20 }}>
              Not allowed access to this client's data
            </div>
          ) : eventsListStatus == "fetching" ? (
            <div
              style={{ fontSize: 20, marginTop: 5 }}
            >{`Loading ${queryParam}...`}</div>
          ) : filteredEvents.length > 0 ? (
            filteredEvents
              .filter(
                (event) =>
                  event.title.includes(filterText) ||
                  formatDate(event.date).includes(filterText) || event.client_user_name.includes(filterText)
              )
              .map((evt) => (
                <Fragment>
                  <tr style={{ backgroundColor: "#BCF1FB", overflow: 'scroll' }}>
                    {/* bookmark */}
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (eventsToOpen.includes(evt[`${eventType}_id`])) {
                          setEventsToOpen(
                            eventsToOpen.filter(
                              (eventVar) => eventVar != evt[`${eventType}_id`]
                            )
                          );
                          return;
                        }
                        setEventsToOpen([
                          ...eventsToOpen,
                          evt[`${eventType}_id`],
                        ]);
                        setShouldOpenCollapse(false);
                        dispatch(
                          getEventDetails({
                            event_type: eventType,
                            event_id: evt[`${eventType}_id`],
                          })
                        );
                        setSelectedEvent(evt);
                        setShouldOpenCollapse(true);
                      }}
                    >
                      {filterParam != "favorite" && (
                        <span>
                          {formatDate(evt.date) != "Invalid date" &&
                            formatDate(evt.date)}
                        </span>
                      )}
                      <span className={classes.EventNoteMain}>{evt.title}</span>
                      {evt.published == 0 && (
                        <span className={classes.DraftStyle}>Draft</span>
                      )}
                      {evt.link && (
                        <a
                          href={evt.link}
                          target="_blank"
                          style={{ color: "#5e72e5" }}
                        >
                          Link
                        </a>
                      )}
                    </td>

                    {filterParam == "all" && (
                      <td>
                        <h5>{evt.client_user_name}</h5>
                      </td>
                    )}


                    <td>
                      {/* OPTIONS */}
                      <div
                        className={[
                          "d-none  d-xl-flex justify-content-around",
                        ].join(" ")}
                      >
                        <a
                          href={`/addEvent/?client=${(filterParam == "favorite") ? "favorite" : evt.client_id}&event_id=${evt[`${eventType}_id`]
                            }&selector=AddOrEdit&eventType=${queryParamSingular}`}
                          role="button"
                          className={classes.OptionButton}
                        >
                          <i
                            className="fas fa-edit"
                            style={{ marginRight: 5 }}
                          ></i>
                          Edit
                        </a>
                        <div
                          onClick={() => {
                            setShouldOpenCollapse(false);
                            dispatch(
                              getEventDetails({
                                event_type: eventType,
                                event_id: evt[`${eventType}_id`],
                              })
                            );
                            setShowCopyModal(true);
                          }}
                          role="button"
                          className={classes.OptionButton}
                        >
                          <i
                            className="fas fa-copy"
                            style={{ marginRight: 5 }}
                          ></i>
                          Copy
                        </div>
                        <div
                          role="button"
                          className={[classes.OptionButton].join(" ")}
                          onClick={(e) => {
                            if (emailStatus == "fetching") {
                              return;
                            }
                            emailBtnRef.current = e.target;
                            dispatch(
                              emailEventToClient({
                                eventType: eventType,
                                client_id: evt.client_id,
                                event_id: evt[`${eventType}_id`],
                              })
                            );
                          }}
                        >
                          <i
                            className="fas fa-at"
                            style={{ marginRight: 5 }}
                          ></i>
                          Email
                        </div>

                        <a
                          href={`/printEvents/?display=${evt[`${eventType}_id`]
                            }&selector=${queryParamSingular}s&client=${clientParam ? clientParam : filterParam
                            }`}
                          className={classes.OptionButton}

                        >
                          <i
                            className="fas fa-print"
                            style={{ marginRight: 5 }}
                          // onClick={console.log('display: ',evt[`${eventType}_id`],'selector: ',queryParamSingular + 's','client: ',clientParam, filterParam)}
                          ></i>
                          Print
                        </a>
                        {(filterParam == "client" || filterParam == "all") && (
                          <div
                            className={classes.OptionButton}
                            onClick={() => {
                              // dispatch(
                              //   addEventToFavorites({
                              //     event_type: eventType,
                              //     event_id: evt[`${eventType}_id`],
                              //   })
                              // );
                              statusDispatch(addEventToFavorites({
                                event_type: eventType,
                                event_id: evt[`${eventType}_id`],
                              }), `${eventType}`,"favorite")


                            }}
                          >
                            <i
                              className="fas fa-heart"
                              style={{ marginRight: 5 }}
                            ></i>
                            Favorite
                          </div>
                        )}



                      </div>

                      <div className="d-xl-none d-block">
                        <Dropdown>
                          <Dropdown.Toggle
                            className={classes.OptionButton}
                            id="dropdown-basic"
                          >
                            Options
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              href={`/addEvent/?client=${(filterParam == "favorite") ? "favorite" : evt.client_id}&event_id=${evt[`${eventType}_id`]
                                }&selector=AddOrEdit&eventType=${queryParamSingular}`}
                            >
                              <a role="button" style={{ color: "#000" }}>
                                <i
                                  className="fas fa-edit"
                                  style={{ marginRight: 5 }}
                                ></i>
                                Edit
                              </a>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <div
                                onClick={() => {
                                  setShouldOpenCollapse(false);
                                  dispatch(
                                    getEventDetails({
                                      event_type: eventType,
                                      event_id: evt[`${eventType}_id`],
                                    })
                                  );
                                  setShowCopyModal(true);
                                }}
                                role="button"
                              >
                                <i
                                  className="fas fa-copy"
                                  style={{ marginRight: 5 }}
                                ></i>
                                Copy
                              </div>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <div
                                role="button"
                                onClick={(e) => {
                                  if (emailStatus == "fetching") {
                                    return;
                                  }
                                  emailBtnRef.current = e.target;

                                  dispatch(
                                    emailEventToClient({
                                      eventType: eventType,
                                      client_id: evt.client_id,
                                      event_id: evt[`${eventType}_id`],
                                    })
                                  );
                                }}
                              >
                                <i
                                  className="fas fa-at"
                                  style={{ marginRight: 5 }}
                                ></i>
                                Email
                              </div>
                            </Dropdown.Item>

                            <Dropdown.Item
                              href={`/printEvents/?display=${evt[`${eventType}_id`]
                                }&selector=${queryParamSingular}s&client=${clientParam ? clientParam : filterParam
                                }`}
                            >
                              <a style={{ color: "#000" }}>
                                <i
                                  className="fas fa-print"
                                  style={{ marginRight: 5 }}
                                ></i>
                                Print
                              </a>
                            </Dropdown.Item>

                            <Dropdown.Item>
                              <div
                                onClick={() => {
                                  // dispatch(
                                  //   addEventToFavorites({
                                  //     event_type: eventType,
                                  //     event_id: evt[`${eventType}_id`],
                                  //   })
                                  // );
                                  statusDispatch(addEventToFavorites({
                                    event_type: eventType,
                                    event_id: evt[`${eventType}_id`],
                                  }), `${eventType}`,"favorite")
                                }}
                              >
                                <i
                                  className="fas fa-heart"
                                  style={{ marginRight: 5 }}
                                ></i>
                                Favorite
                              </div>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>

                      {/* ******************* */}
                    </td>
                    {filterParam != "favorite" && (
                      <td>
                        <Status
                          eventType={eventType}
                          evt={evt}
                          shouldOpenActualResults={shouldOpenActualResults}
                          setShouldOpenActualResults={
                            setShouldOpenActualResults
                          }
                          show={show}
                          setShow={setShow}
                          setShouldOpenCollapse={setShouldOpenCollapse}
                          shouldOpenCollapse={shouldOpenCollapse}
                          setSelectedEvent={setSelectedEvent}
                          selectedEvent={selectedEvent}
                          eventsToOpen={eventsToOpen}
                          setEventsToOpen={setEventsToOpen}
                          user={user}
                        />
                      </td>
                    )}
                    {user?.permissions.edit.exercise && (
                      <td>
                        <input
                          className={classes.CheckBox}
                          type="checkbox"
                          checked={deleteEventsArr.includes(
                            evt[`${eventType}_id`]
                          )}
                          onChange={(e) => {
                            if (
                              deleteEventsArr.includes(evt[`${eventType}_id`])
                            ) {
                              setDeleteEventsArr(
                                deleteEventsArr.filter(
                                  (event) => event != evt[`${eventType}_id`]
                                )
                              );
                            } else {
                              setDeleteEventsArr([
                                ...deleteEventsArr,
                                evt[`${eventType}_id`],
                              ]);
                            }
                          }}
                        />
                      </td>
                    )}
                  </tr>
                  <Collapse
                    in={
                      eventsToOpen.includes(evt[`${eventType}_id`]) &&
                      shouldOpenCollapse
                    }
                    style={{ backgroundColor: "#fff" }}
                    timeout={5}
                  >
                    <tr>
                      <td colSpan="4">
                        <div>
                          {eventDetailsStatus == "fetching" &&
                            Object.keys(evt.details).length < 1 ? (
                            <div
                              style={{
                                textAlign: "center",
                                fontSize: 20,
                                marginTop: 5,
                              }}
                            >
                              Loading...
                            </div>
                          ) : (
                            <EventDetailsComponent
                              event={evt}
                              eventType={eventType}
                              eventDetails={evt.details}
                              shouldOpenActualResults={shouldOpenActualResults}
                              setShouldOpenActualResults={
                                setShouldOpenActualResults
                              }
                              setPreviewImg={setPreviewImg}
                              handlePreviewShow={handlePreviewShow}
                              selectedEvent={selectedEvent}
                              setSelectedEvent={setSelectedEvent}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  </Collapse>
                </Fragment>
              ))
          ) : events.length > 0 ?
            events.map((evt) => (
              <Fragment>
                <tr style={{ backgroundColor: "#BCF1FB", overflow: 'scroll' }}>
                  {/* bookmark */}
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (eventsToOpen.includes(evt[`${eventType}_id`])) {
                        setEventsToOpen(
                          eventsToOpen.filter(
                            (eventVar) => eventVar != evt[`${eventType}_id`]
                          )
                        );
                        return;
                      }
                      setEventsToOpen([
                        ...eventsToOpen,
                        evt[`${eventType}_id`],
                      ]);
                      setShouldOpenCollapse(false);
                      dispatch(
                        getEventDetails({
                          event_type: eventType,
                          event_id: evt[`${eventType}_id`],
                        })
                      );
                      setSelectedEvent(evt);
                      setShouldOpenCollapse(true);
                    }}
                  >
                    {filterParam != "favorite" && (
                      <span>
                        {formatDate(evt.date) != "Invalid date" &&
                          formatDate(evt.date)}
                      </span>
                    )}
                    <span className={classes.EventNoteMain}>{evt.title}</span>
                    {evt.published == 0 && (
                      <span className={classes.DraftStyle}>Draft</span>
                    )}
                    {evt.link && (
                      <a
                        href={evt.link}
                        target="_blank"
                        style={{ color: "#5e72e5" }}
                      >
                        Link
                      </a>
                    )}
                  </td>

                  {filterParam == "all" && (
                    <td>
                      <h5>{evt.client_user_name}</h5>
                    </td>
                  )}


                  <td>
                    {/* OPTIONS */}
                    <div
                      className={[
                        "d-none  d-xl-flex justify-content-around",
                      ].join(" ")}
                    >
                      <a
                        href={`/addEvent/?client=${(filterParam == "favorite") ? "favorite" : evt.client_id}&event_id=${evt[`${eventType}_id`]
                          }&selector=AddOrEdit&eventType=${queryParamSingular}`}
                        role="button"
                        className={classes.OptionButton}
                      >
                        <i
                          className="fas fa-edit"
                          style={{ marginRight: 5 }}
                        ></i>
                        Edit
                      </a>
                      <div
                        onClick={() => {
                          setShouldOpenCollapse(false);
                          dispatch(
                            getEventDetails({
                              event_type: eventType,
                              event_id: evt[`${eventType}_id`],
                            })
                          );
                          setShowCopyModal(true);
                        }}
                        role="button"
                        className={classes.OptionButton}
                      >
                        <i
                          className="fas fa-copy"
                          style={{ marginRight: 5 }}
                        ></i>
                        Copy
                      </div>
                      <div
                        role="button"
                        className={[classes.OptionButton].join(" ")}
                        onClick={(e) => {
                          if (emailStatus == "fetching") {
                            return;
                          }
                          emailBtnRef.current = e.target;
                          dispatch(
                            emailEventToClient({
                              eventType: eventType,
                              client_id: evt.client_id,
                              event_id: evt[`${eventType}_id`],
                            })
                          );
                        }}
                      >
                        <i
                          className="fas fa-at"
                          style={{ marginRight: 5 }}
                        ></i>
                        Email
                      </div>

                      <a
                        href={`/printEvents/?display=${evt[`${eventType}_id`]
                          }&selector=${queryParamSingular}s&client=${clientParam ? clientParam : filterParam
                          }`}
                        className={classes.OptionButton}

                      >
                        <i
                          className="fas fa-print"
                          style={{ marginRight: 5 }}
                        // onClick={console.log('display: ',evt[`${eventType}_id`],'selector: ',queryParamSingular + 's','client: ',clientParam, filterParam)}
                        ></i>
                        Print
                      </a>
                      {(filterParam == "client" || filterParam == "all") && (
                        <div
                          className={classes.OptionButton}
                          onClick={() => {
                            // dispatch(
                            //   addEventToFavorites({
                            //     event_type: eventType,
                            //     event_id: evt[`${eventType}_id`],
                            //   })
                            // );
                            statusDispatch(addEventToFavorites({
                              event_type: eventType,
                              event_id: evt[`${eventType}_id`],
                            }), `${eventType}`,"favorite")
                          }}
                        >
                          <i
                            className="fas fa-heart"
                            style={{ marginRight: 5 }}
                          ></i>
                          Favorite
                        </div>
                      )}



                    </div>

                    <div className="d-xl-none d-block">
                      <Dropdown>
                        <Dropdown.Toggle
                          className={classes.OptionButton}
                          id="dropdown-basic"
                        >
                          Options
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            href={`/addEvent/?client=${(filterParam == "favorite") ? "favorite" : evt.client_id}&event_id=${evt[`${eventType}_id`]
                              }&selector=AddOrEdit&eventType=${queryParamSingular}`}
                          >
                            <a role="button" style={{ color: "#000" }}>
                              <i
                                className="fas fa-edit"
                                style={{ marginRight: 5 }}
                              ></i>
                              Edit
                            </a>
                          </Dropdown.Item>
                          <Dropdown.Item>
                            <div
                              onClick={() => {
                                setShouldOpenCollapse(false);
                                dispatch(
                                  getEventDetails({
                                    event_type: eventType,
                                    event_id: evt[`${eventType}_id`],
                                  })
                                );
                                setShowCopyModal(true);
                              }}
                              role="button"
                            >
                              <i
                                className="fas fa-copy"
                                style={{ marginRight: 5 }}
                              ></i>
                              Copy
                            </div>
                          </Dropdown.Item>
                          <Dropdown.Item>
                            <div
                              role="button"
                              onClick={(e) => {
                                if (emailStatus == "fetching") {
                                  return;
                                }
                                emailBtnRef.current = e.target;

                                dispatch(
                                  emailEventToClient({
                                    eventType: eventType,
                                    client_id: evt.client_id,
                                    event_id: evt[`${eventType}_id`],
                                  })
                                );
                              }}
                            >
                              <i
                                className="fas fa-at"
                                style={{ marginRight: 5 }}
                              ></i>
                              Email
                            </div>
                          </Dropdown.Item>

                          <Dropdown.Item
                            href={`/printEvents/?display=${evt[`${eventType}_id`]
                              }&selector=${queryParamSingular}s&client=${clientParam ? clientParam : filterParam
                              }`}
                          >
                            <a style={{ color: "#000" }}>
                              <i
                                className="fas fa-print"
                                style={{ marginRight: 5 }}
                              ></i>
                              Print
                            </a>
                          </Dropdown.Item>

                          <Dropdown.Item>
                            <div
                              onClick={() => {
                                // dispatch(
                                //   addEventToFavorites({
                                //     event_type: eventType,
                                //     event_id: evt[`${eventType}_id`],
                                //   })
                                // );
                                statusDispatch(addEventToFavorites({
                                  event_type: eventType,
                                  event_id: evt[`${eventType}_id`],
                                }), `${eventType}`,"favorite")
                              }}
                            >
                              <i
                                className="fas fa-heart"
                                style={{ marginRight: 5 }}
                              ></i>
                              Favorite
                            </div>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>

                    {/* ******************* */}
                  </td>
                  {filterParam != "favorite" && (
                    <td>
                      <Status
                        eventType={eventType}
                        evt={evt}
                        shouldOpenActualResults={shouldOpenActualResults}
                        setShouldOpenActualResults={
                          setShouldOpenActualResults
                        }
                        show={show}
                        setShow={setShow}
                        setShouldOpenCollapse={setShouldOpenCollapse}
                        shouldOpenCollapse={shouldOpenCollapse}
                        setSelectedEvent={setSelectedEvent}
                        selectedEvent={selectedEvent}
                        eventsToOpen={eventsToOpen}
                        setEventsToOpen={setEventsToOpen}
                        user={user}
                      />
                    </td>
                  )}
                  {user?.permissions.edit.exercise && (
                    <td>
                      <input
                        className={classes.CheckBox}
                        type="checkbox"
                        checked={deleteEventsArr.includes(
                          evt[`${eventType}_id`]
                        )}
                        onChange={(e) => {
                          if (
                            deleteEventsArr.includes(evt[`${eventType}_id`])
                          ) {
                            setDeleteEventsArr(
                              deleteEventsArr.filter(
                                (event) => event != evt[`${eventType}_id`]
                              )
                            );
                          } else {
                            setDeleteEventsArr([
                              ...deleteEventsArr,
                              evt[`${eventType}_id`],
                            ]);
                          }
                        }}
                      />
                    </td>
                  )}
                </tr>
                <Collapse
                  in={
                    eventsToOpen.includes(evt[`${eventType}_id`]) &&
                    shouldOpenCollapse
                  }
                  style={{ backgroundColor: "#fff" }}
                  timeout={5}
                >
                  <tr>
                    <td colSpan="4">
                      <div>
                        {eventDetailsStatus == "fetching" &&
                          Object.keys(evt.details).length < 1 ? (
                          <div
                            style={{
                              textAlign: "center",
                              fontSize: 20,
                              marginTop: 5,
                            }}
                          >
                            Loading...
                          </div>
                        ) : (
                          <EventDetailsComponent
                            event={evt}
                            eventType={eventType}
                            eventDetails={evt.details}
                            shouldOpenActualResults={shouldOpenActualResults}
                            setShouldOpenActualResults={
                              setShouldOpenActualResults
                            }
                            setPreviewImg={setPreviewImg}
                            handlePreviewShow={handlePreviewShow}
                            selectedEvent={selectedEvent}
                            setSelectedEvent={setSelectedEvent}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                </Collapse>
              </Fragment>
            ))


            : (
              <div>{`No ${queryParam} found`}</div>
            )}
        </tbody>
      </Table>

      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <h4>
            Comments for {eventType}{" "}
            {eventDetailsStatus == "idle" ? eventDetails.title : ""}
          </h4>
          <hr />
          <div class="form-group">
            <textarea
              class="form-control"
              id="eventComment"
              rows="3"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
            ></textarea>
          </div>
          <Button
            onClick={() => {
              if (commentText != "") {
                dispatch(
                  addCommentToEvent({
                    event_id: eventDetails[`${eventType}_id`],
                    event_name: eventDetails.title,
                    client_id: eventDetails.client_id,
                    event_type: eventType,
                    use_json: 1,
                    message: commentText,
                  })
                );
              }
              setCommentText("");
            }}
            style={{
              backgroundColor: "#0061d8",
              outline: "#0061d8",
              marginBottom: 20,
            }}
          >
            Submit Comment
          </Button>
          {eventCommentsStatus == "idle" ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {eventComments.map((comment) => (
                <div
                  className={classes.ChatBubble}
                  style={
                    comment.align == "right"
                      ? { alignSelf: "flex-end" }
                      : {
                        alignSelf: "flex-start",
                        backgroundColor: "#e5e7f5",
                        color: "#000C2D",
                      }
                  }
                >
                  <Fragment>
                    <small>{`${comment.from} on ${comment.longDate}`}</small>
                    <p>{comment.comment}</p>
                  </Fragment>
                </div>
              ))}
            </div>
          ) : eventCommentsStatus == "fetching" ? (
            <p style={{ textAlign: "center", fontSize: 20, marginTop: 5 }}>
              Loading...
            </p>
          ) : (
            <p style={{ textAlign: "center", fontSize: 20, marginTop: 20 }}>
              No previous messages found. Add one above
            </p>
          )}
        </Modal.Body>
      </Modal>

      {/* Template Modal */}
      <Modal show={showTemplateModal} onHide={handleCloseTemplateModal}>
        <Modal.Body>
          {eventsTemplatesStatus == "fetching" ? (
            <div>Loading</div>
          ) : (
            <Table bordered>
              <thead>
                <tr className={classes.TemplateTableHeader}>
                  <td>Workouts</td>
                  <td style={{ float: "right", border: "none" }}>Add</td>
                </tr>
              </thead>
              {allEventsTemplates?.length > 0 &&
                allEventsTemplates.map((eventTemplate) => (
                  <tr>
                    <td>{eventTemplate.note}</td>
                    <td>
                      <a
                        href={`/addEvent/?client=${eventTemplate.clientID}&event_id=${eventTemplate.event_id}&selector=AddOrEdit&eventType=Workout`}
                        target="_blank"
                        style={{ float: "right" }}
                      >
                        <Button size="sm" variant="primary">
                          Add
                        </Button>
                      </a>
                    </td>
                  </tr>
                ))}
            </Table>
          )}
        </Modal.Body>
      </Modal>

      {/* Delete Event Modal */}
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Event(s)?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteEventsArr.length > 1 ? (
            <div>
              You are about to delete multiple {`${eventType}s`}. Are you sure
              you want to continue?
            </div>
          ) : (
            <div>Are you sure you want to delete this {`${eventType}`}?</div>
          )}
          {deletingEventsStatus == "fetching" && (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              dispatch(
                deleteEvents({
                  event_ids: deleteEventsArr,
                  event_type: eventType,
                })
              );
              setDeleteEventsArr([]);
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Copy Event Modal */}
      <Modal show={showCopyModal} onHide={handleCopyClose}>
        <Modal.Header>
          <div>
            <Button
              style={{ marginRight: 20 }}
              onClick={() => setCopyType("copyWorkout")}
            >
              Copy {queryParamSingular}
            </Button>
            <Button onClick={() => setCopyType("copyAndEdit")}>
              Copy & Edit
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          {copyType == "copyWorkout" ? (
            <div>
              {eventDetailsStatus == "fetching" ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: 20,
                    marginTop: 5,
                  }}
                >
                  Loading...
                </div>
              ) : (
                <Fragment>
                  <div className="mb-3">
                    <div>Copy {queryParamSingular} To:</div>
                    <Select
                      options={clientsList.map((client) => ({
                        label: client.clientDisplayName,
                        value: client.clientIDNumber,
                      }))}
                      value={clientsToCopyEvent}
                      onChange={(e) => {
                        setClientsToCopyEvent(e);
                      }}
                      isMulti
                    />
                  </div>
                  <div className="mb-3">
                    <div>New {queryParamSingular} Name</div>
                    <input
                      className="form-control"
                      value={copyWorkoutName}
                      onChange={(e) => setCopyWorkoutName(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <div>New {queryParamSingular} Status</div>
                    <select
                      className="form-control"
                      onChange={(e) => setCopyWorkoutStatus(e.target.value)}
                    >
                      <option value={1} selected={copyWorkoutStaus == 1}>
                        Published
                      </option>
                      <option value={0} selected={copyWorkoutStaus == 0}>
                        Saved as Draft
                      </option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <div>Repeat</div>
                    <select
                      className="form-control"
                      onChange={(e) => setCopyWorkoutRepeat(e.target.value)}
                      value={copyWorkoutRepeat}
                    >
                      <option value={""} selected>
                        None
                      </option>
                      <option value={"daily"} value="daily">
                        Daily
                      </option>
                      <option value={"weekly"} value="weekly">
                        Weekly
                      </option>
                    </select>
                  </div>
                  <div className="mb-3">
                    <div>New {queryParamSingular} Date</div>
                    <DatePicker
                      type="date"
                      dateFormat="MMM dd, yyyy"
                      className="form-control"
                      selected={Date.parse(moment(copyWorkoutDate))}
                      onChange={(date) => {
                        setCopyWorkoutDate(moment(date).format('YYYY-MM-DD'));
                      }}
                    />
                  </div>
                  {copyWorkoutRepeat != "" ? (
                    copyWorkoutRepeat == "daily" ? (
                      <div className="mb-3">
                        <div className="mb-3">
                          <div>Repeat Until</div>
                          <DatePicker
                            type="date"
                            className="form-control"
                            dateFormat="MMM dd, yyyy"
                            selected={Date.parse(moment(copyWorkoutRepeatUntilDaily))}
                            onChange={(date) =>
                              setCopyWorkoutRepeatUntilDaily(moment(date).format('YYYY-MM-DD'))
                            }
                          />
                        </div>
                        <div className="mb-3">
                          <div>Repeat Rate in Days</div>
                          <input
                            type="number"
                            className="form-control"
                            onChange={(e) =>
                              setCopyWorkoutDaysDaily(e.target.value)
                            }
                            value={copyWorkoutDaysDaily}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="mb-3">
                        <div className="mb-3">
                          <div>Repeat Until</div>
                          <input
                            type="date"
                            className="form-control"
                            onChange={(e) =>
                              setCopyWorkoutRepeatUntilWeakly(e.target.value)
                            }
                            value={copyWorkoutRepeatUntilWeekly}
                          />

                        </div>
                        <div>Choose days</div>
                        <div className="d-flex flex-wrap">
                          <div className="col-6">
                            <input
                              type="checkbox"
                              id="day1"
                              value="sun"
                              onChange={(e) => setWeeklyDays(e)}
                            />
                            <label style={{ paddingLeft: 10 }} for="day1">
                              sun
                            </label>
                          </div>
                        </div>
                        <div className="col-6">
                          <input
                            type="checkbox"
                            id="day2"
                            value="mon"
                            onChange={(e) => setWeeklyDays(e)}
                          />
                          <label style={{ paddingLeft: 10 }} for="day2">
                            mon
                          </label>
                        </div>

                        <div className="col-6">
                          <input
                            type="checkbox"
                            id="day3"
                            value="tue"
                            onChange={(e) => setWeeklyDays(e)}
                          />
                          <label style={{ paddingLeft: 10 }} for="day3">
                            tue
                          </label>
                        </div>

                        <div className="col-6">
                          <input
                            type="checkbox"
                            id="day4"
                            value="wed"
                            onChange={(e) => setWeeklyDays(e)}
                          />
                          <label style={{ paddingLeft: 10 }} for="day4">
                            wed
                          </label>
                        </div>

                        <div className="col-6">
                          <input
                            type="checkbox"
                            id="day5"
                            value="thu"
                            onChange={(e) => setWeeklyDays(e)}
                          />
                          <label style={{ paddingLeft: 10 }} for="day5">
                            thurs
                          </label>
                        </div>

                        <div className="col-6">
                          <input
                            type="checkbox"
                            id="day6"
                            value="fri"
                            onChange={(e) => setWeeklyDays(e)}
                          />
                          <label style={{ paddingLeft: 10 }} for="day6">
                            fri
                          </label>
                        </div>

                        <div className="col-6">
                          <input
                            type="checkbox"
                            id="day7"
                            value="sat"
                            onChange={(e) => setWeeklyDays(e)}
                          />
                          <label style={{ paddingLeft: 10 }} for="day7">
                            sat
                          </label>
                        </div>
                      </div>
                    )
                  ) : (
                    <div></div>
                  )}
                </Fragment>
              )}
            </div>
          ) : (
            <div>
              {clientsList.length < 1 || eventDetailsStatus == "fetching" ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: 20,
                    marginTop: 5,
                  }}
                >
                  Loading...
                </div>
              ) : (
                <Fragment>
                  <select
                    className="form-control"
                    onChange={(e) => setCopyEditClient(e.target.value)}
                  >
                    <option value=""></option>
                    {clientsList.map((client) => (
                      <option value={client.clientIDNumber}>
                        {client.clientDisplayName}
                      </option>
                    ))}
                  </select>

                  <p>
                    Choose 1 client to copy to and click "Copy & Go Edit". You
                    will then be able to edit and assign to additional clients.
                  </p>
                </Fragment>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCopyClose}>
            Cancel
          </Button>
          {eventDetailsStatus == "fetching" ? (
            <div></div>
          ) : copyType == "copyWorkout" ? (
            <Button
              variant="primary"
              onClick={() => {
                let clientsArr = [];
                clientsToCopyEvent.forEach((client) =>
                  clientsArr.push(parseInt(client.value))
                );
                clientsArr.filter(client=>Boolean(client))
                if (clientsArr.length < 1) {
                  alert(
                    "You must specify at least one client to copy this event to."
                  );
                  return;
                }
                let copyingToCurrentClient = clientsArr.includes(
                  parseInt(clientParam)
                );
                if (copyingToCurrentClient) {
                  clientsArr = clientsArr.filter(
                    (clientId) => clientId != clientParam
                  );
                  clientsArr = [parseInt(clientParam), ...clientsArr];
                }
                dispatch(
                  copyEventToClients({
                    event_id: eventDetails[`${eventType}_id`],
                    event_type: eventType,
                    additional_client_ids: clientsArr,
                    title: copyWorkoutName,
                    published: copyWorkoutStaus,
                    start_date: copyWorkoutDate,
                    // start_date: copyWorkoutRepeat ? copyWorkoutDate : null,
                    end_date: copyWorkoutRepeat
                      ? copyWorkoutRepeat == "daily"
                        ? copyWorkoutRepeatUntilDaily
                        : copyWorkoutRepeatUntilWeekly
                      : null,
                    recurrence_type: copyWorkoutRepeat
                      ? copyWorkoutRepeat
                      : null,
                    day_string: copyWorkoutRepeat
                      ? copyWorkoutRepeat == "daily"
                        ? copyWorkoutDaysDaily
                        : copyWorkoutDaysWeekly.join()
                      : null,
                    copyingToCurrentClient: copyingToCurrentClient,
                    return_first_created: copyingToCurrentClient ? 1 : 0,
                  })
                );
                console.log(copyingToCurrentClient);
                handleCopyClose();
              }}
            >
              Copy {`${queryParam}`}
            </Button>
          ) : (
            // <a
            //   href={`/addEvent/?client=${copyEditClient}&event_id=${
            //     eventDetails[`${eventType}_id`]
            //   }&selector=AddOrEdit&eventType=${
            //     eventType[0].toUpperCase() + eventType.substring(1)
            //   }&trainer=${user.trainer_id}`}
            //   target="_blank"
            //   style={{ float: "right" }}
            // >
            <Button
              onClick={() => {
                if (copyEditClient == "") {
                  alert("You need to specify a client to copy workout to");
                  return;
                }
                envAwarePost("api/events/api.php", {
                  action: "copyAndEdit",
                  event_id: eventDetails[`${eventType}_id`],
                  event_type: eventType,
                  tgt_client_id: copyEditClient,
                }).then((res) => {
                  // setFoodList(res.data);

                  window.location.href = `/addEvent/?client=${copyEditClient}&event_id=${res.data[`${eventType}_id`]
                    }&selector=AddOrEdit&eventType=${eventType[0].toUpperCase() + eventType.substring(1)
                    }&trainer=${user.trainer_id}`;
                });
                // window.location.href = `/addEvent/?client=${copyEditClient}&event_id=${
                //   eventDetails[`${eventType}_id`]
                // }&selector=AddOrEdit&eventType=${
                //   eventType[0].toUpperCase() + eventType.substring(1)
                // }&trainer=${user.trainer_id}`;
              }}
              style={{ float: "right" }}
            >
              Copy & Go Edit
            </Button>
            // </a>
          )}
        </Modal.Footer>
      </Modal>

      {/* Preview Modal */}
      <Modal show={showPreview} onHide={handlePreviewClose}>
        <Modal.Header closeButton>
          <Modal.Title>{previewImg.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            src={previewImg.preview_src}
            className={classes.ExercisePreviewImg}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default EventsView;
